<app-header></app-header>

@let policies = visiblePolicies$ | async;
@let policiesEnabledMap = policiesEnabledMap$ | async;
@let organization = organization$ | async;
@let drawerEnabled = useDrawer();

<div class="bv-policies-page">
  <section class="bv-policies-page__panel">
    @if (!policies || !policiesEnabledMap || !organization) {
      <div class="bv-policies-page__state">
        <i
          class="bwi bwi-spinner bwi-spin tw-text-muted"
          title="{{ 'loading' | i18n }}"
          aria-hidden="true"
        ></i>
        <span class="tw-sr-only">{{ "loading" | i18n }}</span>
      </div>
    } @else {
      <ul class="bv-policies-list" role="list">
        @for (p of policies; track p.type) {
          <li class="bv-policies-list__item">
            <button type="button" class="bv-policies-list__main" (click)="edit(p, organization)">
              <span class="bv-policies-list__title">
                {{ (drawerEnabled && p.v2?.name ? p.v2.name : p.name) | i18n }}
              </span>
              <span class="bv-policies-list__description">
                {{ (drawerEnabled && p.v2?.description ? p.v2.description : p.description) | i18n }}
              </span>
            </button>

            <div class="bv-policies-list__actions">
              @if (policiesEnabledMap.get(p.type)) {
                <span class="bv-policies-list__status bv-policies-list__status--on">{{
                  "on" | i18n
                }}</span>
              } @else {
                <span class="bv-policies-list__status bv-policies-list__status--off">{{
                  "off" | i18n
                }}</span>
              }

              <button
                [bitMenuTriggerFor]="rowMenu"
                type="button"
                bitIconButton="bwi-ellipsis-v"
                size="small"
                class="bv-policies-row-menu-trigger"
                label="{{ 'options' | i18n }}"
                (click)="$event.stopPropagation()"
              ></button>

              <bit-menu #rowMenu class="bv-policies-row-menu">
                <button type="button" bitMenuItem (click)="edit(p, organization)">
                  {{ "editPolicy" | i18n }}
                </button>
              </bit-menu>
            </div>
          </li>
        }
      </ul>
    }
  </section>
</div>
